var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import CompaniesTableRow from 'modules/infosets/components/CompaniesTableRow.vue';
import { isEmpty } from 'lodash';
let CompaniesTable = class CompaniesTable extends Vue {
    changeStatus(data) {
        return data;
    }
    companiesLoaded() {
        return true;
    }
    mounted() {
        if (!isEmpty(this.companies)) {
            this.companiesLoaded();
        }
    }
};
__decorate([
    Prop({ default: () => [] })
], CompaniesTable.prototype, "companies", void 0);
__decorate([
    Prop({ default: false })
], CompaniesTable.prototype, "loadingStatus", void 0);
__decorate([
    Prop({ default: () => { } })
], CompaniesTable.prototype, "page", void 0);
__decorate([
    Emit('changeStatus')
], CompaniesTable.prototype, "changeStatus", null);
__decorate([
    Emit('companiesLoaded')
], CompaniesTable.prototype, "companiesLoaded", null);
CompaniesTable = __decorate([
    Component({ components: { CompaniesTableRow } })
], CompaniesTable);
export default CompaniesTable;
